import sImg1 from '../images/testimonial/3.jpg'
import sImg2 from '../images/testimonial/2.jpg'



const testimonials = [
    {
        id: '01',
        img: sImg1,
        Des: "Climb the mountain not to plant your flag but to membrace the ways challenge, enjoy the air, and behold the.Climb it see the world, not so the world can see you.This is due to their excellent service competitive pricing",
        title: 'Robert J. Hare',
        sub: "Freight Manager",
    },
    {
        id: '02',
        img: sImg2,
        Des: "I recently used for my logistics needs, and I am thoroughly impressed with their exceptional service. I contacted them, team demonstrated and making the entire process smooth and hassle-free.",
        title: 'Winifred P. Reyes',
        sub: "Freight Manager",
    },
  
]


export default testimonials;